import Referees from 'components/general/Referees'
import React from "react";
import { useViewport } from 'components/general/useViewPort';



/*
Main component
Renders result page for BKG sport
*/
const BkgReferees = ({ data }) => {

  const { breakPoint } = useViewport();

  const isMobile = breakPoint === "sm" || breakPoint === "xs";
  //data?.results?.officials?.forEach(o => console.log(o?.function?.functionCode))

  const judges = data?.results?.officials?.filter(o => /^J[1-9]$/.test(o?.function?.functionCode) || /^[A-J]$/.test(o?.function?.functionCode))
  const otherReferees = data?.results?.officials?.filter(o => !/^J[1-9]$/.test(o?.function?.functionCode) && !/^[A-J]$/.test(o?.function?.functionCode))
  judges?.sort((a, b) => a.order - b.order)
  otherReferees?.sort((a, b) => a.order - b.order)


  return (
    <>
      {!isMobile &&
        <div className="d-flex justify-content-between w-90">
          <div className='w-40'><Referees data={otherReferees} config={{ source: 'official', avoidDuplicates: true }} /></div>
          <div className='w-40'><Referees data={judges} config={{ source: 'official' }} /></div>
        </div>
      }
      {isMobile &&
        <Referees data={data?.results?.officials} config={{ source: 'official', avoidDuplicates: true }} />
      }
    </>
  )
}

export default BkgReferees;